import PermissionSelect from '@adsk/alloy-react-permission-select';

export const PERMISSION_TYPES = {
  USER: 'user',
  ROLE: 'role',
  COMPANY: 'company',
  GROUP: 'group',
};

export const SHEETS_PERMISSION_ACTIONS_MAP = {
  CONTROL: {
    ACTION_LIST: [
      'VIEW',
      'DOWNLOAD',
      'COLLABORATE',
      'PUBLISH_MARKUP',
      'PUBLISH',
      'EDIT',
      'CONTROL',
    ],
    ACTION: 'CONTROL',
    GROUP: 'CONTROL',
    LABEL: 'MANAGE',
    ORDER: 1,
    PILL_VALUE: {
      0: PermissionSelect.PILL_TYPES.FULL,
      1: PermissionSelect.PILL_TYPES.FULL,
      2: PermissionSelect.PILL_TYPES.FULL,
      3: PermissionSelect.PILL_TYPES.FULL,
    },
  },
  EDIT: {
    ACTION_LIST: [
      'VIEW',
      'DOWNLOAD',
      'COLLABORATE',
      'PUBLISH_MARKUP',
      'PUBLISH',
      'EDIT',
    ],
    ACTION: 'EDIT',
    GROUP: 'EDIT',
    ORDER: 2,
    PILL_VALUE: {
      0: PermissionSelect.PILL_TYPES.FULL,
      1: PermissionSelect.PILL_TYPES.FULL,
      2: PermissionSelect.PILL_TYPES.FULL,
    },
  },
  CREATE: {
    ACTION_LIST: [
      'VIEW',
      'DOWNLOAD',
      'COLLABORATE',
      'PUBLISH_MARKUP',
      'PUBLISH',
    ],
    ACTION: 'CREATE',
    GROUP: 'CREATE',
    ORDER: 3,
    PILL_VALUE: {
      0: PermissionSelect.PILL_TYPES.FULL,
      1: PermissionSelect.PILL_TYPES.FULL,
    },
  },
  VIEW_DOWNLOAD_PUBLISH: {
    ACTION_LIST: ['VIEW', 'DOWNLOAD', 'COLLABORATE', 'PUBLISH_MARKUP'],
    ACTION: 'VIEW_DOWNLOAD_PUBLISH',
    GROUP: 'CREATE',
    ORDER: 4,
    PILL_VALUE: {
      0: PermissionSelect.PILL_TYPES.FULL,
      1: PermissionSelect.PILL_TYPES.SEMI,
    },
    hidden: true,
  },
  VIEW_DOWNLOAD: {
    ACTION_LIST: ['VIEW', 'COLLABORATE', 'DOWNLOAD'],
    ACTION: 'VIEW_DOWNLOAD',
    GROUP: 'VIEW',
    ORDER: 5,
    PILL_VALUE: {
      0: PermissionSelect.PILL_TYPES.FULL,
    },
  },
  VIEW: {
    ACTION_LIST: ['VIEW', 'COLLABORATE'],
    ACTION: 'VIEW',
    GROUP: 'VIEW',
    ORDER: 6,
    PILL_VALUE: {
      0: PermissionSelect.PILL_TYPES.SEMI,
    },
  },
};

export const SUBMITTALS_PERMISSIONS = {
  VIEW: '2',
  MANAGE: '1',
};

export const SUBMITTALS_PERMISSION_TYPES = {
  USER: '1',
  COMPANY: '2',
  ROLE: '3',
};

export const WORKFLOWS_ROLES = {
  SUBCONTRACTOR: 'sc',
  GENERAL_CONTRACTOR: 'gc',
  CONSTRUCTION_MANAGER: 'cm',
  ARCHITECT: 'arch',
};
export const WORKFLOW_A = 'US';
export const WORKFLOW_B = 'EU';

export const ISSUES_PERMISSION_ACTION = {
  READ: 'read',
  CREATE: 'create',
  WRITE: 'write',
  DELETE: 'delete',
};

export const ISSUES_PERMISSION_LEVELS = {
  VIEW: 1,
  EDIT: 2,
  CREATE: 3,
  MANAGE: 4,
};

export const PRODUCTS_ORDER = [
  'docs',
  'designCollaboration',
  'modelCoordination',
  'takeoff',
  'autoSpecs',
  'build',
  'cost',
  'insight',
];
